import React, { useState, useEffect, useRef } from "react";
import { handleUnauthorized } from "../../../src/utils/apiHelper";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const ViewPostPageNew = () => {
  const [userData, setUserData] = useState(null); // State to store user details
  const [loading, setLoading] = useState(true); // State to handle loading
  const { id } = useParams();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  useEffect(() => {
    // Function to fetch user data
    const fetchUserData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/postDataById/${id}`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 401) {
          handleUnauthorized(navigate);
          return;
        }
        const data = await response.json();
        setUserData(data.result);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);
  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="tab-content" id="pills-tabContent">
              <div className="row">
                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Title</b>
                    </span>

                    <p> {userData?.title || "N/A"}</p>
                  </div>
                </div>
                {userData?.userId?.fullName && (
                  <div className="col-sm-4">
                    <div className="mb-20">
                      <span>
                        <b>User Name</b>
                      </span>
                      <p>{userData.userId.fullName}</p>
                    </div>
                  </div>
                )}

                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Category Name</b>
                    </span>
                    <p>
                      {userData?.categoryId
                        ?.map((cat) => cat.title)
                        .join(", ") || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Subtitles Language</b>
                    </span>
                    <p>
                      {userData?.subTitleLanguage
                        ?.map((sub) => sub.title)
                        .join(", ") || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Audio Track Language</b>
                    </span>
                    <p>
                      {userData?.audioLanguage
                        ?.map((aud) => aud.title)
                        .join(", ") || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Quality</b>
                    </span>
                    <p> {userData?.quality || "N/A"}</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Status</b>
                    </span>
                    <p> {capitalizeFirstLetter(userData?.status) || "N/A"}</p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Release Date</b>
                    </span>
                    <p>
                      {userData?.releaseDate
                        ? (() => {
                            const date = new Date(userData.releaseDate);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // months are 0-indexed
                            const year = date.getFullYear();
                            return `${day}-${month}-${year}`;
                          })()
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="mb-20">
                    <span>
                      <b>Upload Date</b>
                    </span>
                    <p>
                      {userData?.createdAt
                        ? (() => {
                            const date = new Date(userData.createdAt);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // months are 0-indexed
                            const year = date.getFullYear();
                            return `${day}-${month}-${year}`;
                          })()
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              {userData.status === "rejected" && (
                <div className="row">
                  <div className="col-sm-12">
                    <div className="mb-20">
                      <span>
                        <b>Reason</b>
                      </span>
                      <p>{userData?.reason || "N/A"}</p>
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-sm-12">
                  <div className="mb-20">
                    <span>
                      <b>Description</b>
                    </span>
                    <p> {userData?.description || "N/A"}</p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="mb-20">
                    <span>
                      <b>Movie Poster</b>
                    </span>
                    {userData?.banner ? (
                      <img
                        src={userData.banner}
                        alt="Banner"
                        style={{
                          width: "100%",
                          height: "400px",
                          borderRadius: "8px",
                        }}
                      />
                    ) : (
                      <p>N/A</p>
                    )}
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="mb-20">
                    <span>
                      <b>Video</b>
                    </span>

                    {userData?.video ? (
                      userData.videotype === "video" ? (
                        // Case 1: Normal video file
                        <video
                          controls
                          style={{
                            width: "100%",
                            height: "400px",
                            borderRadius: "8px",
                          }}
                        >
                          <source src={userData.video} type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                      ) : userData.videotype === "youtube" ? (
                        // Case 2: YouTube link
                        <div className="trailer-preview mt-2">
                          <iframe
                            width="100%"
                            height="400"
                            src={userData.video.replace("watch?v=", "embed/")}
                            title="Movie Trailer"
                            frameBorder="0"
                            allowFullScreen
                          ></iframe>
                        </div>
                      ) : (
                        // Case 3: If type not recognized
                        <p>N/A</p>
                      )
                    ) : (
                      // Case 4: No video at all
                      <p>N/A</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mb-20">
                <label>
                  <b>Cast & Crew List</b>
                </label>
              </div>
              <div className="row">
                {userData?.cast?.length > 0 ? (
                  userData.cast.map((castItem, index) => (
                    <div className="col-sm-2" key={castItem._id || index}>
                      <div className="mb-20 text-center">
                        {castItem.image ? (
                          <img
                            src={castItem.image}
                            alt={castItem.name}
                            style={{
                              width: "100px",
                              height: "100px",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <p>No image</p>
                        )}
                        <p>{castItem.name || "N/A"}</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-sm-12">
                    <p>No cast data available</p>
                  </div>
                )}
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <p> No Data Found</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPostPageNew;
